import FilterChip from './FilterChip'
export * from './FilterChip'

export default FilterChip
